import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyHeadToDocument, headDataFromRoute } from '@/seo/head';
import { absoluteUrl } from '@/seo/jsonld';
import { seoForPath } from '@/seo/routes';

interface SiteMetaProps {
  title: string;
  description: string;
  /** Caminho da rota, ex.: "/produto". */
  path: string;
  noindex?: boolean;
}

/**
 * Atualiza o `<head>` ao navegar dentro do site.
 *
 * Quando a rota está no registro de SEO (`src/seo/routes.ts`), vale o registro,
 * e as props ficam só como reserva para rota que ainda não foi registrada. É o
 * registro que gera o HTML entregue a buscadores no build; se a página passasse
 * outro título aqui, o robô e o visitante veriam títulos diferentes.
 */
export function SiteMeta({ title, description, path, noindex }: SiteMetaProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = seoForPath(pathname);
    applyHeadToDocument(
      route
        ? headDataFromRoute(route)
        : { title, description, canonical: absoluteUrl(path), noindex: Boolean(noindex) },
    );
  }, [pathname, title, description, path, noindex]);

  return null;
}
